import {styled} from "@mui/material";

export const Wrapper = styled('div')({
  width: 800,
  height: 600,
  padding: '50px 15px',
  backgroundColor: 'white',
});
